<template>
  <div class="device">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="device-title">
      设备授权记录
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <searchs @onSearch="onSearch" :option="option" />
      </div>
      <div style="display: inline-block;vertical-align: top;">
<!--        <a-button class="createrBtn" @click="showCreateClick">创建设备</a-button>-->
      </div>
    </div>
    <!-- 表格 -->
    <deviceuser-table ref="deviceTable" />
    <!-- 创建设备 -->
    <a-modal v-model="visible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <div class="createTitle">创建设备</div>
      <a-form-model ref="createDevice" v-bind="layout" :model="createDeviceForm" :rules="createDeviceFormRules">
        <a-form-model-item has-feedback label="设备编号" prop="vptNum">
          <a-input v-model="createDeviceForm.vptNum" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="设备名称" prop="name">
          <a-input v-model="createDeviceForm.name" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="地理位置" prop="pos">
          <a-input v-model="createDeviceForm.pos" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="控制指令" prop="cmd">
          <a-input v-model="createDeviceForm.cmd" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="设备状态" prop="state">
          <a-radio-group v-model="createDeviceForm.state">
            <a-radio :value="0" :checked="true">
              关
            </a-radio>
            <a-radio :value="1">
              开
            </a-radio>
          </a-radio-group>
        </a-form-model-item>

      </a-form-model>

      <div class="btn-wrap">
        <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
        <a-button class="create" @click="submitForm('createDevice')">创建</a-button>
      </div>

    </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { addDevice } from "api/deviceuser"
import { hasPermission } from 'utils/hasPermission'

import searchs from "@/components/content/search/Searchs";
import DeviceuserTable from './childComps/DeviceuserTable';

export default {
  name: 'Device',
  components: {
    searchs,
    DeviceuserTable
  },
  data() {
    let checkPending;
    let validateVptNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('设备编号不能为空'));
      } else {
        callback();
      }
    };
    let validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('设备名称不能为空'));
      } else {
        callback();
      }
    };
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,

      createDeviceForm: {
        cmd: null,
        cmdDate: null,
        name: "",
        pos: "",
        state: 0,
        vptNum: "",
      },

      createDeviceFormRules: {
        vptNum: [{validator: validateVptNum, trigger: 'change'}],
        name: [{validator: validateName, trigger: 'change'}]
      },

      option: [
        {
          placeholder: "请输入设备编码或IMEI搜索",
          name: "deviceName",
          deviceName: "",
        },
        {
          placeholder: "请输入昵称搜索",
          name: "userName",
          userName: "",
        }
      ]
    }
  },
  created() {
    const isCustomerView = !hasPermission('/deviceuser/column/name')
      && (hasPermission('/deviceuser/column/vptCode')
        || hasPermission('/deviceuser/column/nickname'))
    if (isCustomerView) {
      this.option[0].placeholder = "请输入设备编码或站点编码搜索"
    }
  },
  methods: {
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      console.log(value)
      this.$refs.deviceTable.deviceName = value[0].deviceName;
      this.$refs.deviceTable.userName = value[1].userName;
      this.$refs.deviceTable.onSearch()
    },
    // 显示创建设备
    showCreateClick() {
      this.createDeviceForm = {
        cmd: null,
        cmdDate: null,
        name: "",
        pos: "",
        state: 0,
        vptNum: "",
      }
      this.visible = !this.visible;
    },
    // 取消创建
    cancel() {
      console.log("取消创建");
      this.visible = !this.visible;
    },
    // 创建设备
    submitForm(formName) {
      const vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          vm.create()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
    * 接口区
    */
    create() {
      // const vm = this;
      // this.spinning = true
      // let objectid = vm.createDeviceForm.objectid
      // let vptNum = vm.createDeviceForm.vptNum
      // let name = vm.createDeviceForm.name
      // let pos = vm.createDeviceForm.pos
      // let state = vm.createDeviceForm.state
      // let cmd = vm.createDeviceForm.cmd
      // addDevice(objectid,vptNum,name,pos,state,cmd)
      //   .then(res => {
      //     console.log(res);
      //     this.spinning = false
      //     if(res.code != "0") {
      //       this.$message.error(res.message);
      //     } else {
      //       this.$message.success('创建设备成功！');
      //       this.$refs.deviceTable.getDeviceListData(0, this.pageSize, value)
      //       this.visible = !this.visible;
      //     }
      //   })
      //   .catch(err => {
      //     vm.spinning = false
      //     console.log(err);
      //     this.$message.error(err.message);
      //   })
    }
  }
}
</script>

<style lang='scss' scoped>
  .device {
    .device-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color:rgba($color: #E84D11, $alpha: .6)
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #E84D11;
    }
  }
</style>
